// extracted by mini-css-extract-plugin
export default {"container":"consent_container__MQJzg","title":"consent_title__q-wCb","img":"consent_img__opDJL"};